import { runtimeEnv } from "../config/runtimeEnv";

export interface CardDetails {
  cardNumber: string;
  expDateMonth: string;
  expDateYear: string;
  cvv: string;
}

export function getCardFieldErrors(card: CardDetails): Record<keyof CardDetails, boolean> {
  const number = card.cardNumber.replace(/\s/g, "");
  const checksum = number.split("").reverse().reduce((sum, digit, index) => {
    const value = Number(digit) * (index % 2 ? 2 : 1);
    return sum + (value > 9 ? value - 9 : value);
  }, 0);
  const validMonth = /^(0?[1-9]|1[0-2])$/.test(card.expDateMonth);
  const validYear = /^\d{2}$/.test(card.expDateYear);
  const now = new Date();
  const year = 2000 + Number(card.expDateYear);
  const expired = validMonth && validYear && (year < now.getFullYear()
    || (year === now.getFullYear() && Number(card.expDateMonth) < now.getMonth() + 1));

  return {
    cardNumber: !/^\d{15,19}$/.test(number) || /^0+$/.test(number) || checksum % 10 !== 0,
    expDateMonth: !validMonth || expired,
    expDateYear: !validYear || expired,
    cvv: !/^\d{3}$/.test(card.cvv),
  };
}

export async function createCardCryptogram(card: CardDetails): Promise<string> {
  if (Object.values(getCardFieldErrors(card)).some(Boolean)) {
    throw new Error("Проверьте реквизиты карты.");
  }
  const Checkout = (window as any).cp?.Checkout;
  if (!Checkout) {
    throw new Error("Платёжная форма ещё загружается. Попробуйте через несколько секунд.");
  }

  for (let attempt = 0; ; attempt += 1) {
    try {
      const checkout = new Checkout({ publicId: runtimeEnv.cloudPaymentsPublicId });
      return await checkout.createPaymentCryptogram({
        ...card,
        expDateMonth: card.expDateMonth.padStart(2, "0"),
      });
    } catch (error) {
      if (!(error instanceof Error) || !/^HTTP xhr (error|abort)/i.test(error.message)) {
        throw error;
      }
      // Retry only the SDK's BIN lookup/cryptogram generation, never the charge.
      if (attempt === 1) {
        throw new Error("Не удалось подключиться к CloudPayments. Эта попытка оплаты не была отправлена. Проверьте соединение и повторите попытку.");
      }
    }
  }
}
